import { render } from "./BaseButtonRed.vue?vue&type=template&id=74fffc91"
const script = {}
script.render = render

export default script